/* eslint-disable eqeqeq */
import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {ListCasinoLobbyCategoryRequest, ListChartsRequest, User} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {CasinoCategoryService} from "../../services/CasinoCategoryService";


interface State extends ListViewState<ListCasinoLobbyCategoryRequest> {
    form? : ListCasinoLobbyCategoryRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class CasinoCategoryListView extends ListView<State, ListChartsRequest> implements FormListener<ListCasinoLobbyCategoryRequest>{

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property : "name", name : "Name"},
        { property : "lobbyOrder", name : "Order", orderBy : "lobbyOrder"},
        { property : "isEnabled", name : "Enabled", renderer : (p : string,n : string,i : any) => i.enabled === true ? "Yes" : "No"}
    ];

    actions = [
        { id : "delete", name : "delete", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CONFIRMATION},
        { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/casino-category/" + item.id }

    ];

    service : CasinoCategoryService;

    constructor(props : Props){
        super(props, "/casino-categories");
        this.state = {...this.state,  listRequest : {...this.state.listRequest, orderBy : "lobbyOrder"}, validationMap : {}, form : {}};
        this.service = getContainer().getCasinoCategoryService();
    }
    onSubmit() : void | Promise<any> {
        if(this.state.form) {
            this.updateListState(this.state.form);
        }
    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: ListCasinoLobbyCategoryRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : User, action : string) : Promise<any> | undefined {
        if(action == "delete") {
            return  this.service.remove(""+item.id);
        }
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "Lobby Categories"
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <div className={"card-box"}>
                    <h4>Search Filters</h4>
                    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <FormGroup className={"form-group"}>
                            <label>Name</label>
                            <FormInput model={"name"} className={"form-control"} validators={[Validators.strLength(1,255)]}/>
                            <span className={"help-text"}>Search for tags </span>
                        </FormGroup>
                        <FormGroup className="form-group">
                            <label>Enabled</label><br/>
                            <FormInput id={"isEnabled"} model="isEnabled" type="checkbox" /><br/>
                            <span className={"help-text"}>When checked displays only enabled categories. Only enabled categories are visible on the player frontend.</span>
                        </FormGroup>
                        <Submit className={"btn btn-primary"}>Search</Submit>
                    </Form>
                </div>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(CasinoCategoryListView);
